import { render, staticRenderFns } from "./CreditsLowAlert.vue?vue&type=template&id=4c815929&"
import script from "./CreditsLowAlert.vue?vue&type=script&lang=ts&"
export * from "./CreditsLowAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports